import { _ as _defineProperty } from './defineProperty-18999f8e.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-00c72f1d.js';
import { forwardRef } from 'react';
import classNames from 'classnames';
import { u as useStyles } from './styles-17912d90.js';
import { j as jsxRuntime } from './jsx-runtime-0f8a08a2.js';

var _excluded = ["as", "disabled", "primary", "secondary", "onClick", "className", "forwardedRef", "children", "variant", "isResponsive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Button(_ref, ref) {
  var _classNames;

  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'button' : _ref$as,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? true : _ref$primary,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? false : _ref$secondary,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
      className = _ref.className;
      _ref.forwardedRef;
      var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children;
      _ref.variant;
      var _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? true : _ref$isResponsive,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  var buttonClasses = classNames(className, classes.root, (_classNames = {}, _defineProperty(_classNames, classes.primary, primary && !secondary), _defineProperty(_classNames, classes.secondary, secondary), _defineProperty(_classNames, classes.responsive, isResponsive), _classNames));
  return /*#__PURE__*/jsxRuntime.jsx(Component, _objectSpread(_objectSpread({
    className: buttonClasses,
    disabled: disabled,
    onClick: disabled ? undefined : onClick,
    ref: ref
  }, props), {}, {
    children: children
  }));
}

var Button$1 = /*#__PURE__*/forwardRef(Button);

export { Button$1 as B };
//# sourceMappingURL=Button-85bbe80f.js.map
